const data = [
	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-0.128, 51.507], [-36, 50], [-73.987, 40.731]]
		},
		name: 'Intercontinental 1',
		cities: ['London', 'New York']
	},
	
	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-0.128, 51.507], [-36, 53], [-73.987, 40.731]]
		},
		name: 'Intercontinental 1',
		cities: ['London', 'New York']
	},

	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-79.534, 8.971], [-85, -1], [-76.878, -12.277]]
		},
		name: 'Intercontinental 1',
		cities: ['Panama', 'Lurin']
	},

	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-76.878, -12.277], [-78.2, -25.7], [-71.62, -33.046]]
		},
		name: 'Intercontinental 1',
		cities: ['Lurin', 'valparaiso']
	},

	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-56.706, -36.488], [-45.3, -33.5], [-46.291, -23.96]]
		},
		name: 'Intercontinental 1',
		cities: ['las toninas', 'Santos']
	},
	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-46.291, -23.96], [-44, -24.15], [-43.209, -22.911]]
		},
		name: 'Intercontinental 1',
		cities: ['santos', 'rio de janeiro']
	},

	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-43.209, -22.911], [-36, -19], [-34, -8], [-38.522, -3.73]]
		},
		name: 'Intercontinental 1',
		cities: ['rio de janeiro', 'fortaleza']
	},

	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-64.835, 17.725], [-64, 29], [-73.987, 40.731]]
		},
		name: 'Intercontinental 1',
		cities: ['st. croix', 'new york']
	},

	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-38.522, -3.73], [-51, 10], [-64.835, 17.725]]
		},
		name: 'Intercontinental 1',
		cities: ['fortaleza', 'st. croix']
	},

	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-64.835, 17.725], [-76, 14.5], [-79.534, 8.971]]
		},
		name: 'Intercontinental 1',
		cities: ['st. croix', 'panama']
	},

	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-2.615, 36.764], [-2.938, 35.292]]
		},
		name: 'Intercontinental 1',
		cities: ['roquetas', 'melilla']
	},
	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[2.65, 39.57], [2.2, 41.7]]
		},
		name: 'Intercontinental 1',
		cities: ['palma', 'barcelona']
	},
	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[2.65, 39.57], [-0.35, 39.467]]
		},
		name: 'Intercontinental 1',
		cities: ['palma', 'valencia']
	},
	{
		type: 'Feature',
		geometry: {
			type: 'LineString',
			coordinates: [[-6.7, 37], [-15.018, 27.798]]
		},
		name: 'Intercontinental 1',
		cities: ['chipiona', 'altavista']
	}
];
export default data;
